import React, { Component, Fragment } from 'react';
import Translator from 'translator';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withStyles, Button, CircularProgress, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';

class FHEContainer extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        classContainer: PropTypes.string,
        hasNoClassContainer: PropTypes.bool,
        error: PropTypes.string,
        loading: PropTypes.bool,
        withBackIcon: PropTypes.bool,
        onClickFunc: PropTypes.func,
        onRender: PropTypes.func,
        children: PropTypes.node
    };

    static defaultProps = {
        hasNoClassContainer: false,
        withBackIcon: false,
        classContainer: null,
        error: '',
        loading: false,
        onClickFunc: null,
        onRender: null,
        children: null
    };

    renderError = () => {
        const { classes, error, onClickFunc } = this.props;
        return (
            <div className={classes.errorContainer}>
                <div className={classes.error}>{error}</div>
                <Button variant="contained" color="primary" onClick={onClickFunc}>
                    {Translator.translate('general.button.retry')}
                </Button>
            </div>
        );
    };

    renderLoading = () => {
        const { classes } = this.props;
        return (
            <div className={classes.loadingContainer}>
                <CircularProgress />
            </div>
        );
    };
    renderChildren = () => {
        const { children, onRender, classes, history, withBackIcon } = this.props;
        return (
            <Fragment>
                {withBackIcon && !history.location.firstPage && (
                    <IconButton
                        aria-label="close"
                        className={classes.closeIcon}
                        size="small"
                        onClick={e => {
                            e.stopPropagation();
                            history.goBack();
                        }}
                    >
                        <Close fontSize="inherit" />
                    </IconButton>
                )}
                {onRender ? onRender() : children}
            </Fragment>
        );
    };

    render() {
        const { classes, hasNoClassContainer, classContainer, loading, error } = this.props;
        if (!hasNoClassContainer || classContainer)
            return (
                <div className={`${!hasNoClassContainer ? classes.container : ''} ${classContainer}`}>
                    {loading ? this.renderLoading() : error ? this.renderError() : this.renderChildren()}
                </div>
            );
        return <Fragment>{loading ? this.renderLoading() : error ? this.renderError() : this.renderChildren()} </Fragment>;
    }
}

const styles = theme => ({
    container: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: 8,
        padding: 50,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '100%',
        width: '100%',
        flex: 1,
        [theme.breakpoints.down('md')]: {
            padding: 30
        },
        [theme.breakpoints.down('sm')]: {
            padding: 20,
            maxHeight: 'none'
        },
        [theme.breakpoints.down('xs')]: {
            padding: 10
        }
    },
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    errorContainer: {
        textAlign: 'center',
        margin: 20
    },
    error: {
        margin: 20
    },
    containerBis: {
        position: 'relative',
        maxHeight: '100%',
        display: 'flex',
        // borderRadius: 8,
        // backgroundColor: theme.palette.background.paper,
        [theme.breakpoints.down('sm')]: {
            maxHeight: 'none'
        }
    },
    closeIcon: {
        position: 'absolute',
        top: 10,
        right: 10,
        zIndex: 30,
        [theme.breakpoints.down('sm')]: {
            top: 0,
            right: 0
        },
        [theme.breakpoints.down('xs')]: {
            top: 0,
            right: 0
        }
    }
});

export default withRouter(withStyles(styles, { withTheme: true })(FHEContainer));



// WEBPACK FOOTER //
// ./data/components/FHEContainer.js